import { Typography } from "antd";

import { RVRow } from "../../layouts/RVFlexbox/RVFlexbox";

import styles from "./RVDescriptionSelectOption.module.scss";

/**
 * Props for the RVDescriptionSelectOption component.
 */
export type RVDescriptionSelectOptionProps = {
    /** Primary label text shown on the left; truncated with a tooltip when it overflows. */
    name: string;
    /** Optional secondary text shown on the right in a muted color. */
    description?: string;
};

/**
 * Renders a select option row with a primary name and an optional secondary description.
 *
 * The name is left-aligned and ellipsis-truncated (with a tooltip on overflow), while the
 * optional description is right-aligned in a muted color. Intended for use as the `label`
 * of an Ant Design `Select` option.
 *
 * @param props - Component props.
 * @returns A flex row containing the option name and optional description.
 *
 * @example
 * ```tsx
 * <RVDescriptionSelectOption name="Account Default VM" description="Campaign VM" />
 * ```
 */
export const RVDescriptionSelectOption = ({ name, description }: RVDescriptionSelectOptionProps): JSX.Element => {
    return (
        <RVRow className={styles.selectDesc} justifyContent="space-between">
            <Typography.Text className={styles.mainText} ellipsis={{ tooltip: name }}>
                {name}
            </Typography.Text>
            {description && <Typography.Text className={styles.descText}>{description}</Typography.Text>}
        </RVRow>
    );
};
